import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LegalPage = ({ title, updated, children, testid }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} | BR Hospitality`;
    return () => {
      document.title = "BR Hospitality | Luxury Hospitality Recruitment & Advisory";
    };
  }, [title]);

  return (
    <div data-testid={testid} className="min-h-screen bg-ivory text-ink">
      <header className="bg-ink py-5">
        <div className="max-w-4xl mx-auto px-6 flex items-center justify-between">
          <Link to="/" data-testid={`${testid}-logo`} className="flex items-center gap-3">
            <img src="/images/br-logo-official.jpg" alt="BR Hospitality monogram" className="w-9 h-9 object-cover" />
            <span>
              <span className="block font-serif text-lg tracking-[0.18em] text-ivory">BR HOSPITALITY</span>
              <span className="block text-[8px] tracking-[0.4em] uppercase text-bronze">
                Recruitment &amp; Advisory
              </span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid={`${testid}-back-home`}
            className="flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-ivory/60 hover:text-bronze transition-colors duration-500"
          >
            <ArrowLeft size={13} strokeWidth={1.5} /> Back to Home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20 lg:py-28">
        <p className="eyebrow mb-4">Legal</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-ink">{title}</h1>
        <p className="mt-4 text-[11px] tracking-[0.2em] uppercase text-ink/40">{updated}</p>
        <div className="mt-12 space-y-10 text-sm leading-relaxed text-ink/70 legal-content">
          {children}
        </div>
      </main>

      <footer className="border-t border-ink/10 py-8">
        <p className="text-center text-[10px] tracking-[0.2em] uppercase text-ink/35">
          © BR Hospitality. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export const Section = ({ title, children }) => (
  <section>
    <h2 className="font-serif text-2xl font-light text-ink mb-3">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export default LegalPage;
